var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('notes',{attrs:{"items":_vm.items,"loading":_vm.loading},on:{"add-note":_vm.addNote,"delete-item":_vm.onDeleteNote}})}
var staticRenderFns = []

export { render, staticRenderFns }